import { useMemo } from 'react'
import { query, where } from 'firebase/firestore'
import { eventInterestsCol } from '../lib/converters'
import { useBatchedSubscriptions } from './useBatchedSubscriptions'
import { isAttending, type EventInterest } from '../types'

export interface FriendEventInterestBuckets {
  interested: string[]
  going: string[]
}

const EMPTY_MAP: Map<string, FriendEventInterestBuckets> = new Map()

export function useFriendEventInterests(memberIds: string[]) {
  const { rows, loading, pending } = useBatchedSubscriptions<EventInterest>(
    memberIds,
    batch => query(eventInterestsCol(), where('userId', 'in', batch)),
    d => d.data() as EventInterest,
  )

  const map = useMemo(() => {
    if (rows.length === 0) return EMPTY_MAP
    const next = new Map<string, FriendEventInterestBuckets>()
    rows.forEach(i => {
      if (!isAttending(i.status)) return
      let bucket = next.get(i.eventId)
      if (!bucket) {
        bucket = { interested: [], going: [] }
        next.set(i.eventId, bucket)
      }
      if (i.status === 'going') bucket.going.push(i.userId)
      else bucket.interested.push(i.userId)
    })
    return next
  }, [rows])

  return { map, rows, loading, pending }
}
